import React from 'react';
import GoModal from './GoModal';


export default class Transition extends React.Component {
  constructor(props) {
    super(props);
    this.getTransition = this.getTransition.bind(this);
  }

  getTransition() {
    switch (this.props.type) {
      case "readySetGo":
        return <GoModal callback={this.props.onEnd} speech={this.props.speech} />
      default:
        break;
    }
  }

  render() {
    return (
      <div className="transitionContainer">
        {this.getTransition()}
      </div>
    );
  }
}
